// Login page for admin mode

import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Form, FormInput, Button, Divider, Header } from 'semantic-ui-react';
import "../css/adminmode.css";
import logo from '../../assets/images/logo512.png';

// endpoint protection
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export default function Login() {
    const hostingServer = `https://sugardb.cs.uct.ac.za/`;

    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const CookieExpirationTime = 30 * 60 * 1000; // 30 minutes
    const [rejected, setRejected] = useState(false);
    const [rejectionMsg, setRejectionMsg] = useState('');

    // function to handle rejection messages
    function handleReject() {
        setRejected(true);
    }

    useEffect(() => {
        if (rejected) {
            setTimeout(() => {
                setRejected(false);
            }, 3000); // clear rejection message after 3 seconds
        }
    }, [rejected]);


    // function to handle form submission: check if user exists in the database, if they do, set a cookie with expiration time
    async function handleSubmit(e) {
        e.preventDefault();

        try {
            await axios.post(`${hostingServer}api/login`, {
                username, password
            })
            .then((res) => {
                if (res.data === 'ConfirmedUser') {
                    // alert('Login Successful');
                    // set cookie with expiration time of 30 minutes
                    const expirationDate = new Date();
                    expirationDate.setTime(expirationDate.getTime() + CookieExpirationTime); // 30 minutes from now
                    cookies.set("TOKEN", res.data, { path: '/', expires: expirationDate });
                    // console.log('cookie set: ', cookies.get("TOKEN"));
                    navigate('/admin',{state: {username: username}});
                } else if (res.data === 'IncorrectPassword') {
                    setRejectionMsg('Incorrect password');
                    handleReject();
                    // alert('Incorrect password');
                }
                else if (res.data === 'UserNotFound') {
                    setRejectionMsg('User does not exist in the database');
                    handleReject();
                    // alert('User does not exist in the database');
                }
            })
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <>
         <Form action="POST" inverted className='login-form'>
            <div style={{display:'flex', marginBottom:'2vh', alignItems:'center', justifyContent:'center'}}>
                <img src={logo} style={{width:"100px", marginRight:'1vh', height:"100px"}} alt="logo" />
                <div>
                    <h1 style={{color:'white', marginBottom:'0vh'}}>SugarDB</h1>   
                </div>
            </div>
            <Divider inverted horizontal>Admin Login</Divider>

            <label>Username</label>
            <FormInput
                style={{marginTop:'1vh'}}
                className= {rejected ? 'error field' : ''}
                icon='user'
                iconPosition='left'
                placeholder='Username'
                onChange={(e) => {setUsername(e.target.value)}}
            />

            <label>Password</label>
            <FormInput
                style={{marginTop:'1vh'}}
                className= {rejected ? 'error field' : ''}
                icon='lock'
                iconPosition='left'
                type='password'
                placeholder='Password'
                onChange={(e) => {setPassword(e.target.value)}}
            />

            { rejected &&
            
                <Header inverted as='h4'>
                    {rejectionMsg}
                </Header>
            }

            <Button color='teal' content='Login' onClick={handleSubmit}/>
        </Form>
        </>
    )
}